{
    "commonUIText": {
        "buttonBack": "Retroceder",
        "prev": "Ant",
        "previous": "Anterior",
        "next": "Siguiente",
        "scrollDownToContinue": "Baje para continuar",
        "close": "Cerrar",
        "lifk": "Kit de campo de infraestructuras vivas",
        "menu": "Menú",
        "settings": "Configuración",
        "references": "Referencias"
    },
    "testingText": {
        "test": "Esto es una prueba.",
        "Hello": "Hola",
        "Array": [
            "Este es el primer elemento.",
            "Este es el segundo elemento.",
            "Este es el tercer elemento."
        ]
    },
    "ReferencesSidebar": {
        "remedies": "Remedios",
        "benefits": "Beneficios",
        "layers": "Capas",
        "search": "Buscar",
        "searchPlaceholder": "Buscar un artículo...",
        "clearSearch": "Borrar búsqueda",
        "missingSearchResults": "¿No ves lo que buscas?",
        "tellUs": "Díganos qué nos falta."
    },
    "UIRightPanel": {
        "dragHandleAriaLabel": "Arrastra para cambiar el tamaño, arrastra hacia abajo para cerrar"
    },
    "UIModal": {
        "submit": "Enviar",
        "cancel": "Cancelar",
        "okay": "Aceptar",
        "discard": "Descarte",
        "delete": "Borrar",
        "clearProgress": "Borrar avance",
        "remove": "Eliminar"
    },
    "TutorialSampleLink": {
        "openSample": "Ver el proyecto de muestra de Magic Johnson Park"
    },
    "ChooseTutorialModal": {
        "title": "Tutoriales guiados",
        "subtitle": "Aprende haciendo. Los tutoriales guiados son recorridos paso a paso que te ayudan a lograr distintos objetivos en el Field Kit.",
        "savedNotice": "Todo lo que crees en los tutoriales se guardará. Construye con libertad: puedes eliminar manualmente cualquier contenido del tutorial cuando termines.",
        "returningTitle": "¡Te damos la bienvenida al Field Kit renovado!",
        "close": "Cerrar tutoriales",
        "skipAndExplore": "Omitir y empezar a explorar",
        "understandingPlace": {
            "title": "Conoce un lugar",
            "description": "Selecciona una ubicación para ver información detallada sobre sus oportunidades y condiciones."
        },
        "exploreMap": {
            "title": "Explora el mapa",
            "description": "Activa la herramienta Capas de datos para revelar las condiciones en todo el mapa."
        },
        "createProject": {
            "title": "Diseña una ubicación",
            "description": "Selecciona una ubicación, agrega remedios y evalúa sus costos y beneficios."
        },
        "engageCommunity": {
            "title": "Recopila conocimiento local",
            "description": "Coloca un marcador, comparte una idea o una observación y encuéntrala de nuevo en el panel de comentarios."
        },
        "sampleSketch": {
            "title": "Recorre el boceto de muestra",
            "description": "Descubre cómo la infraestructura viva revivió Magic Johnson Park y luego crea tu propio boceto."
        }
    },
    "TutorialOverlay": {
        "regionLabel": "Tutorial guiado",
        "skipTour": "Omitir recorrido",
        "gotIt": "Entendido",
        "startExploring": "Comenzar a explorar",
        "exploreMore": "Explorar más tutoriales",
        "stepAnnouncement": "{title} {actionHint} Paso {step} de {count}.",
        "finaleAnnouncement": "{title} Has completado {name}.",
        "steps": {
            "open-site-tool": {
                "title": "Crea una ubicación",
                "body": "Este es el condado de Los Ángeles. Selecciona la herramienta Crear una ubicación {icon} para elegir un lugar en el mapa.",
                "actionHint": "Selecciona la herramienta Crear una ubicación"
            },
            "click-parcel": {
                "title": "Elige un lugar",
                "body": "Haz clic en una parcela del mapa para elegirla como tu ubicación.",
                "actionHint": "Haz clic en una parcela del mapa"
            },
            "read-data-insights": {
                "title": "Consulta los datos de la ubicación",
                "body": "Abre Perspectivas de datos para conocer este lugar y ver qué oportunidades existen en cuanto a calor, inundaciones, hábitat y más.",
                "actionHint": "Abre Perspectivas de datos"
            },
            "read-data-panel": {
                "title": "Explora las perspectivas",
                "body": "Desplázate por los datos para conocer mejor este lugar y descubrir oportunidades de mejora. Haz clic en cualquier tarjeta para ver sus capas de datos correspondientes en el mapa.",
                "actionHint": "Haz clic en cualquier tarjeta para ver sus capas de datos en el mapa"
            },
            "open-layers": {
                "title": "Revela los datos",
                "body": "Activa la herramienta Capas de datos para visualizar las condiciones de este lugar.",
                "actionHint": "Activa la herramienta Capas de datos"
            },
            "toggle-rainfall": {
                "title": "Activa Precipitación anual",
                "body": "Haz clic en la capa Precipitación anual para ver en el mapa cuánta lluvia recibe cada zona.",
                "actionHint": "Haz clic en la capa Precipitación anual"
            },
            "click-readout": {
                "title": "Revela los datos",
                "body": "Haz clic en cualquier punto del mapa para ver la estimación de Precipitación anual de ese lugar.",
                "actionHint": "Haz clic en cualquier punto del mapa"
            },
            "rainfall-aha": {
                "title": "¡Esto es lo que pasa aquí!",
                "body": "Esa es la cantidad de lluvia que recibe este lugar cada año. Cada capa muestra una faceta distinta de la historia del lugar. Cierra la tarjeta de datos cuando termines.",
                "actionHint": "Cierra la tarjeta de datos cuando termines"
            },
            "layer-guidebook": {
                "title": "Profundiza más",
                "body": "Haz clic en el icono de libro en la fila de Precipitación anual para abrir su página de la guía.",
                "actionHint": "Abre la página de la guía"
            },
            "read-guidebook": {
                "title": "Echa un vistazo a la guía",
                "body": "Aquí encontrarás más información sobre esta capa: qué mide, por qué importa y de dónde vienen los datos. Échale un vistazo y cierra la guía cuando termines.",
                "actionHint": "Cierra la guía cuando termines"
            },
            "show-site-info": {
                "title": "Conoce tu ubicación",
                "body": "Abre Información de la ubicación para ver todo sobre el lugar que acabas de elegir.",
                "actionHint": "Abre Información de la ubicación"
            },
            "open-remedies": {
                "title": "Agrega un remedio",
                "body": "Haz clic en la herramienta Remedios para explorar más de 40 intervenciones de infraestructura viva que puedes añadir a tu ubicación.",
                "actionHint": "Haz clic en la herramienta Remedios"
            },
            "place-remedy": {
                "title": "Agrega un remedio a tu ubicación",
                "body": "Arrastra una calcomanía de remedio desde la bandeja y colócala en tu ubicación.",
                "actionHint": "Arrastra un remedio a tu ubicación"
            },
            "show-costs-benefits": {
                "title": "Evalúa el impacto",
                "body": "Abre la pestaña Costos y beneficios para ver cómo afectan tus remedios a la ubicación y qué costos implican.",
                "actionHint": "Abre la pestaña Costos y beneficios"
            },
            "read-costs-benefits": {
                "title": "Haz el balance",
                "body": "Observa los beneficios que tus remedios aportan a la ubicación junto con sus costos. Échale un vistazo y luego cierra el panel.",
                "actionHint": "Cierra el panel cuando termines"
            },
            "open-comments": {
                "title": "Activa los comentarios",
                "body": "Haz clic en el botón de comentarios para activar la herramienta de comentarios.",
                "actionHint": "Haz clic en el botón de comentarios"
            },
            "drop-comment-pin": {
                "title": "Coloca un marcador",
                "body": "Haz clic en cualquier punto del mapa para dejar un comentario.",
                "actionHint": "Haz clic en cualquier punto del mapa"
            },
            "choose-category": {
                "title": "Elige una categoría",
                "body": "Las categorías de comentarios son opcionales, pero ayudan a mantener los comentarios organizados. Abre este menú para seleccionar una.",
                "actionHint": "Abre el menú de categorías"
            },
            "pick-category": {
                "title": "¿Cuál encaja?",
                "body": "Elige la categoría que mejor describa lo que quieres compartir.",
                "actionHint": "Elige una categoría"
            },
            "write-comment": {
                "title": "Escribe tu comentario",
                "body": "Añade un comentario y haz clic en la flecha amarilla o pulsa Intro para publicarlo. También puedes hacer clic en el icono del clip debajo del campo de texto para adjuntar una imagen o un documento. Los comentarios son visibles para todos en el proyecto. ¿Qué quieres compartir?",
                "actionHint": "Escribe tu comentario y haz clic en la flecha amarilla o pulsa Intro"
            },
            "view-comments": {
                "title": "Explora tus comentarios",
                "body": "Haz clic en el icono de comentario para abrir el panel y ver todos los comentarios añadidos al mapa.",
                "actionHint": "Abre el panel de comentarios"
            },
            "open-a-comment": {
                "title": "Aquí están todos tus comentarios",
                "body": "Haz clic en cualquier comentario para ir a él en el mapa. También puedes ordenar, filtrar u ocultar comentarios desde este panel.",
                "actionHint": "Haz clic en un comentario del panel"
            },
            "find-tutorials": {
                "title": "Aquí están todos los tutoriales",
                "body": "Abre tu menú de cuenta cuando quieras para encontrar y comenzar otro tutorial.",
                "actionHint": "Abre tu menú de cuenta para comenzar otro tutorial"
            },
            "sample-welcome": {
                "title": "Te damos la bienvenida al Living Infrastructure Field Kit",
                "body": "Esta herramienta de co-diseño ayuda a planificar y financiar proyectos de beneficios múltiples integrando sistemas construidos, naturales y sociales para que las personas y los lugares prosperen. Veamos cómo la infraestructura viva ayudó a revivir Magic Johnson Park tras años de mal uso.",
                "actionHint": "",
                "manualLabel": "Siguiente"
            },
            "sample-history": {
                "title": "Infraestructura viva en acción",
                "body": "Magic Johnson Park, antes un sitio contaminado de ExxonMobil en Willowbrook, fue renovado en 2021 gracias a una alianza entre el Departamento de Parques y Recreación del condado de Los Ángeles, Obras Públicas del condado de Los Ángeles y la Autoridad de Desarrollo del condado de Los Ángeles. El parque cuenta con un innovador sistema de aguas pluviales que desvía y trata la escorrentía de las comunidades vecinas para prevenir inundaciones y contaminación, y conservar el agua.",
                "actionHint": "",
                "manualLabel": "Siguiente"
            },
            "sample-site": {
                "title": "La ubicación",
                "body": "Este contorno es la ubicación: la sección sur de Magic Johnson Park, la parte del parque que planifica este boceto. Todo lo que ves dentro se diseñó aquí, en el Field Kit.",
                "actionHint": "",
                "manualLabel": "Siguiente"
            },
            "sample-comments": {
                "title": "Necesidades impulsadas por la comunidad",
                "body": "Los marcadores como este son comentarios, usados para recopilar las perspectivas de la comunidad y del trabajo de campo durante las fases iniciales críticas de un proyecto. Este señala una necesidad. Los estudios del sitio y comentarios como este mostraron que la zona alrededor del parque necesitaba ayuda con la contaminación, las inundaciones y el acceso a áreas verdes.",
                "actionHint": "",
                "manualLabel": "Siguiente"
            },
            "sample-opportunities": {
                "title": "Lo que dicen los datos",
                "body": "Los datos de la ubicación indican para qué está mejor preparada. Abre Perspectivas de datos para ver cómo puntúa esta zona de Willowbrook.",
                "actionHint": "Abre Perspectivas de datos"
            },
            "sample-opportunities-list": {
                "title": "Resiliencia ante inundaciones basada en datos",
                "body": "Las oportunidades clasifican lo que esta ubicación puede aportar mejor. Aquí la captación de aguas pluviales destaca: el lago puede recoger escorrentía de mucho más allá del parque. Eso protege a la comunidad de las inundaciones y crea un espacio de encuentro que genera empleos y mejora la salud pública.",
                "actionHint": "",
                "manualLabel": "Siguiente"
            },
            "sample-remedies": {
                "title": "Diseñar con remedios",
                "body": "Las calcomanías como esta son remedios: las acciones que hacen realidad el diseño. Este boceto usa un estanque de almacenamiento, un chapoteadero, un centro comunitario, senderos y jardines nativos. El estanque y el humedal captan y filtran la escorrentía de la cuenca circundante, redirigiéndola para apoyar el hábitat, el riego y a la comunidad aquí en Willowbrook.",
                "actionHint": "",
                "manualLabel": "Siguiente"
            },
            "sample-explore": {
                "title": "¡Explora este boceto y luego crea el tuyo!",
                "body": "Explora los comentarios, remedios y beneficios para ver cómo la infraestructura viva transformó Magic Johnson Park. Los costos que se muestran son educativos e ilustrativos y solo cubren la sección sur del parque. ¿Qué podrías bocetar para tu propia comunidad? Como dice Willy, residente de toda la vida: “Lo que este nuevo parque hace por mi comunidad es traer belleza donde antes hubo tragedia. Llevo aquí más de 64 años. Estuve aquí cuando todo esto no era más que edificios viejos y cosas así. En mi opinión, es lo mejor que pudieron haber hecho por Willowbrook”.",
                "actionHint": "",
                "manualLabel": "Listo"
            }
        },
        "finale": {
            "understandingPlace": {
                "title": "¡Buen trabajo!",
                "body": "Has completado {name}. Todo el contenido que creaste en el tutorial se ha guardado y puedes eliminarlo cuando quieras. ¿Todo listo para poner en práctica lo aprendido? Explora el Field Kit por tu cuenta o prueba otro tutorial."
            },
            "exploreMap": {
                "title": "¡Buen trabajo!",
                "body": "Has completado {name}. Todo el contenido que creaste en el tutorial se ha guardado y puedes eliminarlo cuando quieras. ¿Todo listo para poner en práctica lo aprendido? Explora el Field Kit por tu cuenta o prueba otro tutorial."
            },
            "createProject": {
                "title": "¡Buen trabajo!",
                "body": "Has completado {name}. Todo el contenido que creaste en el tutorial se ha guardado y puedes eliminarlo cuando quieras. ¿Todo listo para poner en práctica lo aprendido? Explora el Field Kit por tu cuenta o prueba otro tutorial."
            },
            "engageCommunity": {
                "title": "¡Buen trabajo!",
                "body": "Has completado {name}. Todo el contenido que creaste en el tutorial se ha guardado y puedes eliminarlo cuando quieras. ¿Todo listo para poner en práctica lo aprendido? Explora el Field Kit por tu cuenta o prueba otro tutorial."
            },
            "sampleSketch": {
                "title": "¡Buen trabajo!",
                "body": "Has terminado el recorrido por Magic Johnson Park. ¿Todo listo para bocetar tu propia visión? Explora el Field Kit por tu cuenta o prueba un tutorial guiado."
            }
        }
    },
    "tooltipText": {
        "help": "Soporte",
        "menu": "Menú",
        "comment": "Comentario"
    },
    "UILoadingIndicator": {
        "loading": "Cargando…",
        "loadingAnimAltText": "Una animación de tres pops secuenciales que indican que la carga está en progreso."
    },
    "MapControls": {
        "zoomIn": "Acercar",
        "zoomOut": "Alejar",
        "zoomAnnouncement": "Mapa ampliado al {level} por ciento",
        "layers": "Capas de datos",
        "pitch2D": "Vista en 2D",
        "pitch3D": "Vista en 3D",
        "pitch2DLabel": "Mostrar mapa en 2D",
        "pitch3DLabel": "Mostrar mapa en 3D",
        "sketchVisibility": "Visibilidad"
    },
    "BaseMapToggle": {
        "satelliteLabel": "Mostrar vista satélite",
        "streetLabel": "Mostrar vista de mapa",
        "mapView": "Vista del mapa",
        "basemap": "Mapa",
        "satelliteOption": "Satélite"
    },
    "InfoHeader": {
        "landingTitle": "Kit de campo de infraestructuras vivas",
        "landingTitleShort": "Kit de campo",
        "menu": "Menú"
    },
    "MobileNavigation": {
        "landingTitleShort": "Kit de campo",
        "menu": "Menú",
        "primers": "Cartillas",
        "guides": "Guías",
        "toggleLanguage": "Idioma"
    },
    "LanguageMenu": {
        "languageTag": "ES",
        "selectLanguage": "Seleccionar idioma"
    },
    "ContentMenu": {
        "contentMenu": "Recursos",
        "primers": "Cartillas",
        "guides": "Guías"
    },
    "LoginControls": {
        "logIn": "Iniciar sesión",
        "signUp": "Regístrate",
        "visioningTool": "Herramienta de visualización"
    },
    "InfoFooter": {
        "logo": "El Kit de Campo de Infraestructura Viva",
        "livingInfrastructure": "Infraestructura Viva",
        "home": "Inicio",
        "signUp": "Registrarse",
        "logIn": "Iniciar sesión",
        "instagram": "Instagram",
        "linkedIn": "LinkedIn",
        "privacyPolicy": "Política de Privacidad",
        "termsOfService": "Términos de Servicio",
        "attributionText": "Creado con esmero y comunidad por <a href=\"https://acceleratela.org/\" target=\"_blank\">Accelerate Resilience L.&nbsp;A. (ARLA)</a> y <a href=\"https://spherical.studio/\" target=\"_blank\">Spherical</a>. Se publicará bajo una licencia de código abierto. Accelerate Resilience L.&nbsp;A. es un proyecto patrocinado por Rockefeller Philanthropy Advisors.",
        "copyrightText": "Derechos de autor ©2024 Living Infrastructure Field Kit. Todos los derechos reservados."
    },
    "unauthorizedText": {
        "instructions": "No está autorizado para ver esta página",
        "linkBack": "Ir a Inicio"
    },
    "Auth": {
        "welcomeHeading": "¡Bienvenido de nuevo!",
        "welcomeSubheading": [
            "“Este no es nuestro mundo con árboles en él. Es un mundo de árboles,<br/> donde los humanos apenas han llegado.”<br/>—Richard Powers",
            "“Agua es Vida / Mní wičhóni.”</br>—Frase Lakota",
            "“Agua engendra agua, el suelo es el útero,</br>la vegetación la partera.”</br>—Millán Millán",
            "“El ciudadano infraestructural no es solo cuidado a gran escala,</br>sino cuidado en perpetuidad.“</br>—Deb Chachra",
            "“Todo lo que tocas, lo cambias.</br>Todo lo que cambias, te cambia a ti.“</br>—Lauren Oya Olamina (Octavia E. Butler)",
            "“Los ecosistemas son muy similares a las sociedades humanas—</br>se construyen sobre relaciones. Cuanto más fuertes son,</br>más resiliente es el sistema.”</br>—Suzanne Simard",
            "“Los Ángeles es un tazón de agua; está lleno; es libre.”</br>—Megan Dorame",
            "“La vida no conquistó el mundo a través del combate, sino mediante el trabajo en red.\"</br>—Lynn Margulis",
            "“Todas las formas de vida son, de hecho, procesos y no cosas.“</br>—Merlin Sheldrake"
        ],
        "emailLabel": "Correo electrónico",
        "passwordLabel": "Contraseña",
        "emailValidation": "Por favor, ingrese una dirección de correo electrónico válida",
        "passwordValidation": "Por favor, ingrese una contraseña",
        "passwordMinLengthValidation": "La contraseña debe tener al menos 8 caracteres",
        "emailPlaceholder": "Ingresa la correo electrónico",
        "passwordPlaceholder": "Ingresa tu contraseña",
        "confirmPlaceholder": "Confirme la contraseña",
        "footerText": "Creado con cuidado y comunidad por <a class=\"underline\" target=\"_blank\" href=\"https://acceleratela.org/\">Accelerate Resilience L. A. (ARLA)</a> y <a class=\"underline\" target=\"_blank\" href=\"https://spherical.studio/\">Spherical</a>. Se publicará bajo una licencia de código abierto. Accelerate Resilience L.A. es un proyecto patrocinado por Rockefeller Philanthropy Advisors.",
        "termsLinkText": "Términos de Servicio",
        "privacyLinkText": "Política de Privacidad",
        "handsImageAltText": "En una animación colorida, una rama frondosa, un desagüe pluvial y varias manos humanas entrelazadas forman una trenza, representando los sistemas construidos, naturales y sociales que sustentan la infraestructura viva.",
        "treeImageAltText": "En una animación colorida, una persona riega un limonero con agua de lluvia de una cisterna. Gusanos, ranas, mariposas, hongos y flores emergen donde el agua se acumula en la base del árbol.",
        "checkOut": "Explora el Kit de Campo por tu cuenta."
    },
    "LoginView": {
        "forgotPassword": "¿Olvidaste tu Contraseña?",
        "formHeader": "Iniciar sesión",
        "buttonText": "Iniciar sesión",
        "signUpText": "¿Necesitas una cuenta?",
        "signUpLinkText": "Registrate",
        "errorMessage": "Contraseña incorrecta",
        "butterflyImageAltText": "Animación de una mariposa, un gusano y varias plantas y flores volando con el viento"
    },
    "SignupView": {
        "welcomeHeading": "¡Bienvenido!",
        "welcomeSubheading": "El Kit de Campo incluye una herramienta de co-diseño gratuita y recursos de aprendizaje para ayudar a las comunidades a imaginar, planificar y solicitar financiamiento para proyectos de múltiples beneficios.",
        "whenYouSignup": "Cuando te registras, puedes:",
        "identifySiteOpportunities": "Identificar oportunidades de ubicación para infraestructura viva",
        "useData": "Usar datos para entender los lugares.",
        "inviteCommunity": "Invitar a la participación de la comunidad",
        "sketchTogether": "Dibujar junto a otros para imaginar nuevas ideas de proyectos.",
        "learn": "Conocer los costos y beneficios de tu diseño.",
        "download": "Descargar propuestas de proyectos",
        "watch": "Ver un video resumen",
        "formHeader": "Registrarse",
        "buttonText": "Crear cuenta",
        "logInText": "¿Ya tienes una cuenta?",
        "logInLinkText": "Iniciar sesión",
        "firstNameLabel": "Nombre de pila",
        "lastNameLabel": "Apellido",
        "organizationLabel": "Organización (opcional)",
        "organizationPlaceholder": "Ingresa la organización",
        "firstNamePlaceholder": "Ingresa el nombre",
        "lastNamePlaceholder": "Ingresa el apellido",
        "privacyLabel": "Estoy de acuerdo con los <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/terms\">Términos de Servicio</a> y la <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/privacy\">Política de Privacidad</a>.",
        "marketingLabel": "Quiero recibir correos electrónicos con consejos, actualizaciones de productos y más (opcional)",
        "privacyError": "Por favor, acepta nuestros Términos y Política de Privacidad",
        "firstNameError": "Por favor, ingresa tu nombre.",
        "lastNameError": "Por favor, ingresa tu apellido.",
        "errorMessage": "Error al registrarse",
        "errorAccountExists": "Ya existe una cuenta con este correo electrónico",
        "errorNoShareToken": "Solo puedes registrarte con un enlace de colaborador válido",
        "polygonAlt": "Un polígono de cuatro lados con círculos verdes en los vértices y un signo de más en el centro.",
        "dataLayersAlt": "Tres cuadrados vistos desde un ángulo están apilados, flotando, uno sobre otro, con el cuadrado de abajo siendo azul oscuro y los otros progresivamente más claros.",
        "sketchAlt": "Cuatro formas coloridas están dispuestas en dos filas.",
        "guidebookAlt": "Un libro abierto con una cubierta azul, con las páginas hacia arriba.",
        "exportAlt": "Un lápiz rojo flota sobre un papel naranja con escritura."
    },
    "SignupButton": {
        "buttonText": "Registrarse"
    },
    "ForgotPasswordView": {
        "formHeader": "¿Olvidaste tu contraseña?",
        "formSubheader": "Para restablecer tu contraseña, ingresa tu correo electrónico y te enviaremos un enlace.",
        "buttonText": "Envíame el enlace de restablecimiento",
        "linkBack": "Volver a la página de inicio de sesión",
        "successHeader": "¡Instrucciones enviadas!",
        "successSubHeader": [
            "Revisa tu correo electrónico en ",
            "y sigue las instrucciones"
        ],
        "errorMessage": "Error al restablecer su contraseña",
        "birdAltText": "Imagen de un pájaro volando."
    },
    "PasswordResetView": {
        "welcomeHeading": "Bienvenido a la herramienta de visualización",
        "welcomeSubheading": "Elija una contraseña para su cuenta.",
        "passwordPlaceholder": "Ingresa una nueva contraseña",
        "confirmPlaceholder": "Confirmar nueva contraseña",
        "newPasswordLabel": "Nueva contraseña",
        "confirmPasswordLabel": "Confirmar contraseña",
        "formHeader": "Ingresa nueva contraseña",
        "confirmLabel": "Confirme la contraseña",
        "buttonText": "Elija una contraseña",
        "passwordConfirmationValidation": "Por favor, confirme su contraseña",
        "passwordsMustMatch": "Las contraseñas deben coincidir",
        "errorMessage": "Su contraseña no pudo crearse",
        "loading": "Cargando…",
        "linkBack": "Regresar a la página de inicio de sesión"
    },
    "PrivacyModal": {
        "formHeader": "Política de Privacidad Actualizada",
        "formSubheader": "Bienvenido de nuevo. Hemos publicado un nuevo <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/terms\">Términos de Servicio</a> y una <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/privacy\">Política de Privacidad</a> como parte de nuestro lanzamiento público. Por favor, revisa y acepta para continuar utilizando el Living Infrastructure Field Kit.",
        "buttonText": "Acepto",
        "errorMessage": "Por favor, acepta los términos y la política de privacidad para continuar."
    },
    "WorkshopsGrid": {
        "loading": "Cargando proyectos",
        "loadError": "No se pudieron cargar los proyectos…",
        "noWorkshops": "No se ha creado ningún proyecto aún.",
        "createNew": "Nuevo proyecto"
    },
    "WorkshopCard": {
        "edit": "Editar proyecto",
        "duplicate": "Proyecto duplicado.",
        "sampleSketch": "Proyecto de muestra",
        "sampleSketchTooltip": "Explora la transformación de este parque para ver cómo la infraestructura viva puede remodelar tu comunidad."
    },
    "SketchModal": {
        "createHeader": "Crear un nuevo proyecto",
        "editHeader": "Renombrar proyecto",
        "nameLabel": "Nombre*",
        "delete": "Borrar",
        "cancelWarningHeading": "¿Estás seguro de que quieres descartar este proyecto?",
        "cancelWarning": "Una vez que descartes este proyecto, no podrás acceder a él nuevamente.",
        "cancelUpdateWarningHeading": "¿Estás seguro de que deseas descartar estos cambios en el proyecto?",
        "cancelUpdateWarning": "Una vez que descartes, los cambios en tu proyecto no se guardarán.",
        "submitWorkshopError": "Tu proyecto no se puede guardar en este momento. Te sugerimos restablecer tu conexión a internet o buscar una más rápida. Si eso no funciona, ten paciencia mientras resolvemos el problema de nuestro lado. ¡Gracias por tu paciencia!",
        "nameValidation": "Por favor, ingrese un nombre",
        "deleteConfirmation": "¿Estás seguro de que deseas eliminar este proyecto? Una vez que lo elimines, no podrás acceder a él nuevamente.",
        "deleteWorkshopError": "Tu proyecto no se puede eliminar en este momento. Te sugerimos restablecer tu conexión a internet o buscar una más rápida. Si eso no funciona, ten paciencia mientras resolvemos el problema de nuestro lado. ¡Gracias por tu paciencia!",
        "submit": "Enviar",
        "showCosts": "Mostrar costos",
        "showCostsInfoTip": "Muestra el costo total de creación y cuidado de tu proyecto en el panel de perfil.",
        "save": "Guardar",
        "toggleCosts": "Cambiar visibilidad de costos"
    },
    "EditUserModal": {
        "headline": "Editar usuario",
        "label0": "Nombre",
        "label1": "Apellido",
        "label2": "Correo electrónico",
        "label3": "Función",
        "cancelButton": "Cancelar",
        "button": "Actualizar",
        "delete": "Borrar",
        "submitUserError": "El usuario no pudo actualizarse",
        "deleteUserError": "El usuario no pudo borrarse",
        "firstNameValidation": "Por favor, ingrese un nombre",
        "lastNameValidation": "Por favor, ingrese un apellido",
        "emailValidation": "Por favor, ingrese una dirección de correo válida",
        "loading": "Cargando usuario…"
    },
    "SearchControl": {
        "search": "Buscar",
        "searchFor": "Buscar una ubicación..."
    },
    "TopNavbar": {
        "export": "Exportar",
        "share": "Compartir"
    },
    "HomeButton": {
        "backToHome": "Volver a casa",
        "home": "Inicio"
    },
    "LogoLink": {
        "lifk": "Kit de Campo de Infraestructura Viva"
    },
    "NavBreadcrumbs": {
        "projectDefault": "Proyecto",
        "breadcrumbs": "Ruta de navegación"
    },
    "ProjectName": {
        "projectDefault": "Proyecto",
        "projectName": "Nombre del proyecto",
        "clickToSelect": "Haz clic para seleccionar el proyecto",
        "editProject": "Editar proyecto"
    },
    "ProjectNameInput": {
        "projectName": "Nombre del proyecto",
        "saveSuccess": "Nombre del proyecto actualizado",
        "nameValidationError": "Por favor, ingresa un nombre de proyecto",
        "duplicateNameWarning": "Un proyecto ya existe con este nombre. Por favor intenta con un nombre diferente.",
        "saveError": "Un error ocurrió al guardar",
        "editInstructions": "Ingresa el nombre de tu proyecto, luego haz clic en Entrar para enviar y guardar"
    },
    "SiteDropdown": {
        "mySites": "Mis ubicaciones",
        "site": "Ubicación",
        "sites": "Ubicaciones",
        "selectASite": "Selecciona una ubicación",
        "createASite": "Crear una ubicación",
        "emptyProject": "Crea una ubicación para obtener información de datos, diseñar con remedios y más.",
        "unauthEmptyProject": "Este proyecto no tiene ninguna ubicación. Pídele al propietario del proyecto que cree una ubicación para comenzar."
    },
    "ShareModal": {
        "header": "Compartir",
        "submitText": "Invitar",
        "emailValidation": "Por favor, ingresa direcciones de correo electrónico válidas.",
        "emailLimitError": "Puedes invitar un máximo de 25 direcciones de correo electrónico a la vez.",
        "roleValidation": "Por favor, selecciona un rol",
        "accessHeader": "Personas con Acceso",
        "inviteSuccess": "Invitaciones enviadas a colaboradores",
        "collaboratorRemoved": "Colaborador eliminado de este proyecto.",
        "generalError": "Error al invitar a colaboradores.",
        "alreadyInvited": "ya ha sido invitado a este proyecto.",
        "alreadyACollaborator": "ya es colaborador en este proyecto.",
        "singleCollaboratorError": "no se pudo agregar como colaborador.",
        "publicLinkLabel": "Enlace público",
        "publicLinkLabelInfoTooltip": "Cualquier persona con el enlace público puede <span class=\"md:hidden\"><br></span> acceder a este proyecto sin una cuenta. <span class=\"md:hidden\"><br></span> <a class='underline' target='_blank' href='https://help.la.livinginfrastructure.org/en/articles/9930995-sharing-sketches'>Más información</a>",
        "publicLinkEnableTooltip": "Habilitar enlace público",
        "publicLinkDisableTooltip": "Deshabilitar enlace público",
        "publicLinkDescription": "Cuando los visitantes accedan a este enlace, el mapa hará zoom en tu contenido. Si aún no tienes contenido, considera crear un sitio antes de compartirlo.",
        "publicLinkRolesDescription": "Cualquier persona con un enlace público puede",
        "publicLinkSuccess": "¡Enlace copiado!",
        "publicLink": "Copiar enlace",
        "publicLinkRoles": {
            "contributor": "Contribuir",
            "viewer": "Solo lectura"
        },
        "roleDropdownTooltipEditor": "Como editor, no puedes editar el acceso al enlace público.",
        "publicLinkRoleLabel": "Permiso del enlace público"
    },
    "CollaboratorEmailsInput": {
        "inviteHeader": "Invitar Colaboradores",
        "tooltipText": "Los colaboradores pueden editar <span class=\"md:hidden\"><br></span>el proyecto y deben tener una cuenta. <span class=\"md:hidden\"><br></span><a class='underline' target='_blank' href='https://help.la.livinginfrastructure.org/en/articles/9930995-sharing-sketches'>Más información</a>",
        "emailPlaceholder": "Ingresa correos electrónicos separados por comas.",
        "remove": "Eliminar",
        "infoIconTooltip": "Información sobre permisos y requisitos de colaboradores",
        "roleLabel": "Permiso de colaborador"
    },
    "PublicSketchClosedView": {
        "header": "está&nbsp;cerrado",
        "bodyOne": "Gracias por tu interés en contribuir a la",
        "bodyTwo": "La oportunidad de colaborar en este proyecto ha cerrado. Si deseas ponerte en contacto, comunícate con",
        "bodyThree": "directamente.",
        "CTAAnon": "Explora el Kit de Campo por tu cuenta.",
        "buttonTextAnon": "Regístrate",
        "buttonTextUser": "Regresar a casa",
        "organizationDefault": "esta organización"
    },
    "CollaboratorRow": {
        "remove": "Eliminar",
        "confirmRemoveHeading": "¿Estás seguro de que deseas eliminar el acceso?",
        "confirmRemove": "Una vez que elimines el acceso de una persona, no podrá participar en este proyecto.",
        "inviteSent": "Invitación enviada",
        "user": "Usuario",
        "permissionLabel": "Permiso para"
    },
    "MapToolbar": {
        "comments": "Agregar comentarios",
        "guidebook": "Guía",
        "layers": "Capas de datos",
        "remedies": "Agregar remedios",
        "createSite": "Crear una ubicación",
        "editSite": "Editar ubicación",
        "createStory": "Crear una historia"
    },
    "UICloseButton": {
        "close": "Cerrar"
    },
    "OnboardingDialog": {
        "firstTimeUseHeader": "Empieza a explorar",
        "firstTimeUseDescription": "Encuentra y crea una ubicación para aprender sobre un lugar, y explora remedios de infraestructura viva.",
        "firstTimeUseButtonText": "Encontrar un lugar",
        "onboardingHeader": "Conoce una ubicación",
        "onboardingDescription": "Crea una ubicación para explorar el uso del terreno, la propiedad, los límites, las cuencas hidrográficas y los territorios indígenas.",
        "onboardingButtonText": "Crear una ubicación"
    },
    "UICollapseButton": {
        "expand": "Expandir",
        "collapse": "Colapsar"
    },
    "LayersPanel": {
        "title": "Capas de Datos",
        "closePanel": "Cerrar panel de capas de datos",
        "searchPrompt": "Buscar una capa de datos...",
        "clearSearch": "Borrar búsqueda",
        "viewBy": "Ver por:",
        "azView": "A-Z",
        "packView": "Paquete",
        "noPackResults": "No hay paquetes que coincidan con esta búsqueda. Las capas coincidentes están disponibles en la lista de la A a la Z.",
        "viewAZResults": "Ver resultados de la A a la Z"
    },
    "PackLayers": {
        "showAll": "Mostrar capas no coincidentes",
        "showLess": "Ocultar capas no coincidentes"
    },
    "UINavMenu": {
        "logIn": "Inicia sesión",
        "logInDescription": "para crear tus propios sitios, diseñar remedios y más.",
        "knowledgeBase": "Centro de ayuda",
        "contact": "Soporte",
        "tutorials": "Tutoriales guiados",
        "logout": "Cerrar sesión",
        "toggleLanguage": "Idioma",
        "export": "Exportar",
        "share": "Compartir",
        "guidebook": "Guía",
        "sphericalAdmin": "Administración Spherical",
        "profile": "Perfil",
        "commPref": "Preferencias de comunicación"
    },
    "AccountLanguage": {
        "languagePreferences": "Preferencias de idioma"
    },
    "AccountMenuHeader": {
        "anonymous": "Anónimo",
        "workshopAdmin": "Administrador",
        "editor": "Editor",
        "contributor": "Contribuidor",
        "viewer": "Espectador",
        "guest": "Invitado",
        "workshopAdminTooltip": "Puedes crear y editar sitios, agregar remedios y dejar comentarios. También puedes invitar y eliminar colaboradores y administrar sus roles.",
        "editorTooltip": "Puedes crear y editar sitios, agregar remedios y dejar comentarios. También puedes invitar colaboradores.",
        "contributorTooltip": "Puedes agregar remedios y dejar comentarios.",
        "viewerTooltip": "Puedes ver sitios y reaccionar a los remedios."
    },
    "UISticker": {
        "sticker": "Etiqueta"
    },
    "UISettingsButton": {
        "settings": "Configuraciones"
    },
    "RemediesLayer": {
        "submitNoteError": "Sus notas no se pueden actualizar en este momento. Le sugerimos que restablezca su conexión a Internet o que busque una más rápida. Si eso no funciona, tenga paciencia mientras resolvemos el problema por nuestra parte. Gracias por su paciencia.",
        "confirmDeleteHeading": "¿Estás seguro de que quieres eliminar este remedio?",
        "confirmDelete": "Una vez que elimines un remedio, tú y todos en este taller no podrán acceder a él.",
        "remedy": "remedio",
        "squareFeet": "pies cuadrados",
        "remedyMarker": "marcador de remedio",
        "dollars": "dólares",
        "likeRemedy": "Me gusta este remedio",
        "unlikeRemedy": "Ya no me gusta este remedio",
        "likeCount": "me gusta"
    },
    "RemedyContextMenu": {
        "learn": "Aprender",
        "customize": "Notas",
        "duplicate": "Copiar",
        "delete": "Borrar",
        "editFootprint": "Editar huella"
    },
    "RemedyNoteModal": {
        "cancelWarningHeading": "¿Está seguro de que desea descartar los cambios de esta nota?",
        "cancelWarning": "Una vez descartados, los cambios de la nota no se guardarán. ",
        "title1": "Añadir",
        "title2": "Detalles",
        "notes": "notas"
    },
    "SiteContextMenu": {
        "duplicate": "Copiar",
        "delete": "Eliminar",
        "editPoly": "Editar forma"
    },
    "SelectSketchDropdown": {
        "selectProject": "Seleccionar Sitio"
    },
    "SketchBanner": {
        "start": "Haga clic para añadir puntos y dibujar su ubicación.",
        "sketchReadyToClose": "Haz clic en cualquiera de los puntos finales en cualquier momento para completar la forma y crear tu ubicación.",
        "edit": "Edite su ubicación añadiendo, eliminando y moviendo los puntos.",
        "resize": "Haz clic y arrastra cualquier punto para escalar tu ubicación.",
        "parcelSelect": "Haz clic en un área del mapa para crear una ubicación.",
        "guestSavePrompt": "Para guardar tu ubicación, crea una cuenta gratuita o inicia sesión.",
        "userSavePrompt": "Guarda tu ubicación para agregar remedios",
        "saveAndSignup": "Guardar y registrarse",
        "save": "Guardar",
        "cancel": "Cancelar"
    },
    "RemedyTooltip": {
        "footprint": "Huella/Superficie:",
        "aboveground": "Sobre el suelo",
        "belowground": "Subterráneo",
        "canopy": "Dosel",
        "ground": "Suelo",
        "totalFootprintWarning": "Este remedio es más grande que la huella total de tu ubicación.",
        "sumFootprintsWarning": "Este remedio es más grande que la huella restante de tu ubicación.",
        "learnMore": "Más información",
        "perYear": "/año"
    },
    "FootprintBanner": {
        "edit": "Agrega, elimina y mueve puntos para editar tu huella de remediación.",
        "rotate": "Haz clic y arrastra para rotar tu huella.",
        "resize": "Haz clic y arrastra cualquier punto para escalar tu huella.",
        "save": "Guardar",
        "cancel": "Cancelar"
    },
    "EditModeMenu": {
        "edit": "Editar",
        "scale": "Escala",
        "rotate": "Rotar",
        "fixedFootprint": "Este remedio tiene un tamaño de huella fijo."
    },
    "EffectsBanner": {
        "added": "añadido",
        "remedyOutsidePolygon": "El remedio está fuera de los límites de tu sitio. Arrástralo dentro de los límites del sitio para incluirlo.",
        "missingOut": "Está dejando pasar",
        "sqftAdded1": "Se añadieron",
        "sqftAdded2": "pies cuadrados a",
        "sqftRemoved1": "Se eliminaron",
        "sqftRemoved2": "pies cuadrados de"
    },
    "WarningBanner": {
        "totalFootprintBanner": "Agregaste un remedio más grande que la huella total de tu ubicación.",
        "sumFootprintsBanner": "Tus remedios ahora exceden la huella de la ubicación.",
        "rateLimited": "Está ocurriendo demasiado a la vez, así que tu último cambio no se guardó. Debería resolverse en un momento.",
        "siteTooLarge": "Este sitio excede el límite de 100 m² para calcular y exportar métricas, pero puede seguir dibujando.",
        "atLeast3Points": "Las huellas de remediación deben incluir al menos 3 puntos.",
        "invalidSitePolygon": "Los bordes de la ubicación no pueden entrelazarse.",
        "invalidFootprintPolygon": "Los bordes de la huella no pueden entrelazarse.",
        "aqueductshedsLayer": "Esta capa incluye varios estados de EE.UU.; es probable que tenga que alejar el zoom para verla.",
        "zoomIn": "Acércate para ver los datos del $dataLayerNames.",
        "zoomOut": "Acerca el zoom para ver los datos del $dataLayerNames.",
        "zoomBoth": "Ajusta el nivel de zoom para ver los detalles del $dataLayerNames.",
        "and": "y"
    },
    "CostsSummary": {
        "outOf": "fuera de",
        "cost": "Presupuesto",
        "care": "Cuidado"
    },
    "BenefitsSummary": {
        "benefits": "colectivos"
    },
    "SiteInformationPanel": {
        "information": "Información",
        "coordinates": "Coordenadas",
        "site": "Ubicación",
        "siteFootprint": "Huella de la ubicación",
        "location": "Ubicación"
    },
    "BudgetSection": {
        "budget": "Presupuesto",
        "editBudget": "Editar presupuesto de ubicación",
        "creation": "Creación",
        "annualCare": "Cuidado Anual",
        "creator": "Creador",
        "creatorTip": "El creador será acreditado como el autor del sitio en cualquier exportación.",
        "creationBudget": "Presupuesto de Creación",
        "creationBudgetTipProject": "Este es el costo máximo objetivo inicial para tu proyecto, basado en los presupuestos combinados de todos tus sitios, incluyendo planificación, diseño y construcción.\n\nSi no se han ingresado presupuestos para algunos de tus sitios, se utilizarán presupuestos predeterminados basados en el tamaño de cada uno de esos sitios.",
        "creationBudgetTipSite": "Este es el costo máximo objetivo inicial para tu sitio, incluyendo planificación, diseño y construcción.\n\nSi no ingresas un presupuesto, se utilizará un presupuesto predeterminado basado en el tamaño de tu sitio.",
        "annualCareBudget": "Presupuesto Anual de Cuidado",
        "annualCareBudgetTipProject": "Este es el costo máximo anual objetivo para tu proyecto, basado en los presupuestos combinados de todos tus sitios, incluyendo operaciones, mantenimiento y monitoreo. Este costo se puede multiplicar por la duración de tu proyecto para calcular un costo total de cuidado.\n\nSi no se han ingresado presupuestos para algunos de tus sitios, se utilizarán presupuestos predeterminados basados en el tamaño de cada uno de esos sitios.",
        "annualCareBudgetTipSite": "Este es el costo máximo anual objetivo para tu sitio, incluyendo operaciones, mantenimiento y monitoreo. Este costo se puede multiplicar por la duración de tu proyecto para calcular un costo total de cuidado.\n\nSi no ingresas un presupuesto, se utilizará un presupuesto predeterminado basado en el tamaño de tu sitio."
    },
    "UISkeleton": {
        "mapMarker": "Marcador de mapa"
    },
    "GuidebookRemedySpecs": {
        "creation": "Creación",
        "care": "Cuidado",
        "perYear": "/año",
        "creationIcon": "Icono de costo de creación",
        "creationTooltip": "El costo inicial de planificación, diseño e implementación.",
        "creationTooltipEditable": "El costo inicial de planificación, diseño e implementación para la huella predeterminada.",
        "careIcon": "Icono de costo de cuidado",
        "careTooltip": "El costo anual de mantenimiento, operaciones y monitoreo.",
        "careTooltipEditable": "El costo anual de mantenimiento, operaciones y monitoreo para la huella predeterminada.",
        "footprintTooltip": "El área de superficie predeterminada (no editable)",
        "footprintTooltipEditable": "El área de superficie predeterminada (editable)",
        "placement": "Colocación",
        "placementIcon": "Icono de colocación",
        "footprint": "huella $size",
        "editable": "editable",
        "notEditable": "no editable",
        "extraLarge": "extra grande",
        "large": "grande",
        "medium": "mediano",
        "small": "pequeño"
    },
    "StormwaterSection": {
        "water": "Agua",
        "none": "Ninguno"
    },
    "RainfallCard": {
        "roofRainfall": "Precipitación del techo",
        "onsite": "En el lugar",
        "offsite": "Fuera del sitio",
        "totalRainfall": "Total de Precipitación",
        "runoff": "Escorrentía",
        "onsiteTooltip": "La cantidad de agua de lluvia que cae en tu sitio o techo, que se puede recolectar utilizando remedios más pequeños.",
        "offsiteTooltip": "La cantidad de escorrentía de aguas pluviales que fluye dentro de los 250 pies de su sitio (en la superficie o en desagües pluviales), que podría ser desviada a sitios más grandes para su recolección utilizando remedios más grandes.",
        "personYearsDisclaimer": "Los años-persona representan la población que podría ser abastecida con agua durante un año, basado en el estándar de California de 17,155 galones por persona."
    },
    "UIBodyPopup": {
        "placeholderComment": "Agrega tu comentario...",
        "submitComment": "Enviar comentario"
    },
    "UICommentCategoryTag": {
        "chooseCategory": "Elige una categoría"
    },
    "UICommentCategorySelect": {
        "title": "Categoría",
        "header": "Elige una categoría",
        "menuAriaLabel": "Categorías de comentarios",
        "description": "Las categorías son opcionales y pueden ayudar a mantener los comentarios organizados.",
        "emptyState": "Agrega una nueva categoría para que esté disponible para los colaboradores del proyecto. Las categorías son opcionales y pueden ayudar a mantener los comentarios organizados.",
        "addCategory": "Agregar nueva categoría",
        "editCategory": "Editar categoría",
        "aboutCategory": "Acerca de esta categoría"
    },
    "CommentCategoryModal": {
        "newCategory": "Nueva Categoría",
        "editCategory": "Editar Categoría",
        "nameLabel": "Nombre",
        "nameYourCategory": "Nombra tu categoría",
        "nameValidation": "Por favor, introduce un nombre para tu categoría.",
        "descriptionLabel": "Descripción",
        "descriptionPlaceholder": "Describe tu categoría o da ejemplos",
        "icon": "Ícono",
        "selectIcon": "Selecciona un ícono",
        "iconValidation": "Por favor, selecciona un ícono.",
        "save": "Guardar",
        "delete": "Eliminar",
        "saveError": "No se pudo guardar esa categoría. Inténtalo de nuevo.",
        "deleteError": "No se pudo eliminar esa categoría. Inténtalo de nuevo.",
        "confirmDeleteHeading": "¿Eliminar categoría?",
        "confirmDelete": "¿Estás seguro de que deseas eliminar esta categoría? Eliminarla la quitará de todos los comentarios a los que se les haya asignado esta categoría.",
        "confirmCloseHeading": "¿Estás seguro de que deseas descartar los cambios en los detalles de esta categoría?",
        "confirmClose": "Una vez que elijas descartar, no podrás acceder a ellos nuevamente."
    },
    "UIIconPickerMenu": {
        "title": "Selecciona un ícono",
        "searchPlaceholder": "Busca un ícono...",
        "searchAriaLabel": "Buscar íconos",
        "clearSearch": "Borrar búsqueda",
        "noResults": "No encontramos ninguna coincidencia."
    },
    "UIFileUploadButton": {
        "maxFiles": "Solo puedes subir hasta 5 archivos a la vez.",
        "attachFile": "Adjunta hasta 5 archivos",
        "fileTooLarge": "es demasiado grande para subir. Por favor, elige un archivo más pequeño que",
        "forbiddenFileType": "no es un tipo de archivo compatible.",
        "maxFilesReached": "Solo puedes subir hasta 5 archivos a la vez.",
        "imageModerationFailure": "puede contener contenido dañino y violar nuestros Términos de Servicio. Si crees que esta decisión se tomó por error, por favor contacta a nuestro equipo de soporte."
    },
    "UIFilePreview": {
        "remove": "Eliminar",
        "clickToView": "Haz clic para ver"
    },
    "ResponseActions": {
        "edit": "Editar",
        "delete": "Borrar",
        "actionsMenu": "Menú de acciones de comentarios",
        "cancel": "Cancelar",
        "save": "Guardar",
        "repliesSingular": "responder",
        "repliesPlural": "respuestas",
        "menuActions": "Acciones del menú",
        "userProfilePicture": "Imagen de perfil del usuario para",
        "anonymous": "ANÓNIMO"
    },
    "UIEmailIcon": {
        "userProfilePicture": "Foto de perfil del usuario para"
    },
    "ShowDraftComment": {
        "commentMapMarker": "Comentario del marcador del mapa"
    },
    "CommentMapMarker": {
        "closedMarker": "Marcador de Comentario Cerrado",
        "userProfilePicture": "Foto de perfil del usuario"
    },
    "CommentsLayer": {
        "unread": "sin leer",
        "replies": "respuestas",
        "commentBy": "Comentario por"
    },
    "CommentPopup": {
        "comment": "Comentario",
        "confirmDeleteHeading": "¿Estás seguro de que deseas eliminar este comentario?",
        "confirmDelete": "Una vez que elimines un comentario, tú y todos en este proyecto perderán el acceso a él.",
        "edit": "Editar",
        "delete": "Borrar",
        "cancel": "Cancelar",
        "save": "Guardar",
        "submitButton": "Enviar comentario",
        "actionsMenu": "Menú de acciones de comentarios",
        "mapMarker": "Comentar marcador del mapa",
        "addReplyPlaceholder": "Agrega tu respuesta…",
        "submitReply": "Enviar respuesta",
        "confirmDeleteReplyHeading": "Borrar Reply?",
        "confirmDeleteReply": "¿Estás seguro de que deseas eliminar esta respuesta? Una vez que la elimines, no podrás acceder a ella nuevamente.",
        "confirmDeleteThreadHeading": "Borrar Thread?",
        "confirmDeleteThread": "¿Estás seguro de que deseas eliminar este hilo? Una vez que lo elimines, no podrás acceder a él nuevamente."
    },
    "CostsBenefitsPanel": {
        "projectCosts": "Costos del Proyecto",
        "siteCosts": "Costos del Sitio",
        "remedyBenefits": "Beneficios de Remedios",
        "mobileVisitDesktopProject": "Visita la versión de escritorio para agregar remedios y ver el impacto de tu proyecto",
        "mobileVisitDesktopAllSites": "Visita la versión de escritorio para agregar remedios y ver el impacto de tus sitios",
        "mobileVisitDesktopSite": "Visita la versión de escritorio para agregar remedios y ver el impacto de tu sitio",
        "mobileVisitDesktopAlt": "Una ilustración de la contaminación.",
        "effects": "Efectos totales",
        "globalEffects": "Impacto global",
        "fullBar": "Una barra llena representa el máximo de puntos que un emplazamiento de este tamaño podría alcanzar razonablemente",
        "defaultBudgetFullBar1": "El presupuesto predeterminado es",
        "userSetBudgetFullBar1": "Presupuesto personalizado con límite de",
        "budgetFullBar2": "Puede fijar su propia cantidad de forma personalizada en",
        "budgetFullBarLink": "Detalles del sitio",
        "total": "Total",
        "disclaimer": "Actualmente, las estimaciones están en fase de pruebas y estamos ajustando nuestros cálculos a partir de los aportes de personas como usted. Si hay algo que le resulte extraño, no dude en comunicárnoslo.",
        "totalCost": "Presupuesto total",
        "globalCost": "Presupuesto general",
        "remediesOutsideWarning": "Los remedios colocados fuera de la ubicación no se cuentan en la puntuación. Arrastra todos los remedios a tu ubicación para incluir sus efectos.",
        "footprintWarning1": "Tus remedios exceden el presupuesto de la ubicación.",
        "footprintWarning2": "del sitio. Considere eliminar una o más.",
        "and": "y",
        "aboveground": "sobre el suelo",
        "belowground": "subterráneo",
        "canopy": "dosel",
        "ground": "suelo",
        "icon": "icono",
        "outsideLAWarning": "Los cálculos pueden ser menos precisos para ubicaciones fuera del condado de LA."
    },
    "UIReferenceIcon": {
        "learnMore": "Aprender más",
        "ariaLearnMore": "Abre el manual para aprender más."
    },
    "BudgetModal": {
        "editBudget": "Editar Presupuesto",
        "budgetLabel": "Presupuesto",
        "budgetValidation": "El presupuesto tiene que ser una cantidad válida en dólares.",
        "confirmCloseHeading": "¿Está seguro de que desea descartar los cambios de presupuesto?",
        "confirmClose": "Una vez que descarte los cambios de presupuesto, no tendrá acceso a ellos de nuevo.",
        "updateSketchError": "Su sitio no puede ser actualizado en este momento. Le recomendamos que restablezca su conexión a Internet o que busque una conexión más rápida. De no funcionar, tenga paciencia mientras resolvemos el problema por nuestra parte. ¡Muchas gracias por su paciencia!",
        "done": "Hecho",
        "defaultBudgetInfo": "Este es un presupuesto predeterminado basado en el tamaño total de tu ubicación",
        "defaultBudget": "Presupuesto predeterminado",
        "customBudgetInfo": "basado en el tamaño de tu ubicación"
    },
    "ShowCostsToggle": {
        "showCostsInfoTipProject": "Controla la visibilidad de los costos del proyecto, los presupuestos y los costos de los remedios que agregas a tu proyecto.",
        "showCostsInfoTipSite": "Controla la visibilidad de los costos del sitio, los presupuestos y los costos de los remedios que agregas a tu proyecto.",
        "toggleCosts": "Alternar Visibilidad de Costos",
        "showCosts": "Mostrar costos"
    },
    "SiteDetailsModal": {
        "siteDetails": "Detalles de la ubicación",
        "nameLabel": "Nombre*",
        "creatorLabel": "Creador",
        "descriptionLabel": "Descripción",
        "descriptionPlaceholder": "¿Por qué ha creado esta ubicación? ¿Por qué es importante esta ubicación para usted y su comunidad?",
        "nameValidation": "Campo obligatorio. Por favor, nombre su ubicación.",
        "nameLengthValidation": "El nombre debe tener menos de 68 caracteres.",
        "creatorLengthValidation": "El nombre del creador debe tener menos de 68 caracteres.",
        "confirmCloseHeading": "¿Está seguro de que desea descartar estos detalles de la ubicación?",
        "confirmClose": "Una vez que descarte estos detalles de la ubicación, no tendrá acceso a ellos de nuevo.",
        "duplicateNameError": "Ya existe una ubicación con este título. Por favor, pruebe con un título diferente.",
        "updateSketchError": "Su sitio no puede ser actualizado en este momento. Le recomendamos que restablezca su conexión a Internet o que busque una conexión más rápida. De no funcionar, tenga paciencia mientras resolvemos el problema por nuestra parte. ¡Muchas gracias por su paciencia!",
        "done": "Hecho"
    },
    "ExportsContainer": {
        "genericError": "Su exportación no puede completarse en este momento. Le sugerimos que restablezca su conexión a Internet o que busque una más rápida. Si esto no funciona, espere mientras resolvemos el problema. ¡Muchas gracias por su paciencia!"
    },
    "ExportModal": {
        "exportSketch": "Exportar",
        "selectTool": "¿Qué le gustaría exportar?",
        "exportFormat": "Formato de exportación",
        "CSV": "CSV",
        "PDF": "PDF",
        "DOCX": "DOCX",
        "JPG": "JPEG (imagen de alta resolución)",
        "helpCenter": "Obtenga más información sobre las exportaciones y los formatos",
        "toolRequiredError": "Seleccione al menos un elemento para exportar.",
        "exportIsLoading": "La exportación podría tardar unos minutos. Puedes hacer clic fuera de la ventana modal para seguir trabajando mientras se descarga.",
        "sites": "Ubicaciones",
        "comments": "Comentarios",
        "export": "Exportar",
        "noData": "No había datos para exportar.",
        "loadingAnimAltText": "Animación de dos pájaros de patas largas parados en el agua. Uno estira periódicamente el cuello y bate las alas."
    },
    "CommonSiteProfile": {
        "projectName": "Nombre del Proyecto",
        "datetimeCreated": "Fecha de creación (UTC)",
        "name": "Nombre",
        "creator": "Creador",
        "description": "Descripción",
        "remedies": "Remedios",
        "sqft": "pies cuadrados",
        "benefits": "Beneficios",
        "opportunities": "Oportunidades",
        "siteBy": "Ubicación creada por",
        "siteDisclaimer": "Esto proporciona una visión general de cómo podría verse la ubicación. No está destinado a ser una propuesta de diseño verificada y está sujeto a análisis de viabilidad, diseño detallado y permisos.",
        "benefitsSubtext": "Los beneficios se modelan exclusivamente con base en los remedios incluidos en la ubicación. Los beneficios no toman en consideración las condiciones de la ubicación, como la cantidad de escurrimiento disponible para la recolección de agua de lluvia, que debe evaluarse de forma independiente. Se modelan empíricamente para demostrar la cantidad relativa de cada beneficio anticipado, y una barra completa representa el beneficio más razonable que podría lograrse considerando el área de la ubicación. Estos valores están sujetos a un análisis de desempeño más riguroso de diseños detallados. Para más información sobre la metodología de datos, visita el Living Infrastructure Field Kit en livinginfrastructure.org.",
        "costsSubtext": "Estos costos están modelados exclusivamente en función de los remedios incluidos en el sitio. No consideran costos específicos del sitio, como la remediación del suelo o el reubicación de servicios públicos, los cuales deben evaluarse de manera independiente. Las estimaciones se basan en los costos de materiales y mano de obra locales a lo largo de la vida útil del proyecto designado. Para más información sobre la metodología de datos, visita el Living Infrastructure Field Kit en livinginfrastructure.org.",
        "stormwaterSubtext": "Las cifras de precipitación se estiman en función de la cantidad de lluvia que cae en el sitio durante un año promedio o un evento de tormenta del percentil 85. El área de contribución de escorrentía y los cálculos de escorrentía fuera del sitio se basan en la escorrentía que fluye dentro de 250 pies del sitio (por encima del suelo o en desagües pluviales). Para más información sobre la metodología de datos, visita el Living Infrastructure Field Kit en livinginfrastructure.org.",
        "creationSubheader": "Planificación, diseño y construcción",
        "careSubheader": "Mantenimiento, operaciones y monitoreo anuales",
        "opportunitiesSubtext": "Las oportunidades se basan en los datos disponibles y son relativas al Condado de Los Ángeles. Un nivel alto indica que pueden ser necesarias mejoras. Estos datos deben complementarse con la opinión de la comunidad y estudios del sitio. Para más información sobre la metodología de los datos, visita el Kit de Campo de Infraestructura Viva en livinginfrastructure.org.",
        "landSubtext": "La cobertura del suelo se basa en imágenes aéreas y datos de lidar. Para más información sobre la metodología de los datos, visita el Living Infrastructure Field Kit en livinginfrastructure.org.",
        "existingProjectsSubheader": "Medida W del Condado de L.A., Medida A y Proyectos de Infraestructura LA dentro del área de recorrido del sitio.",
        "annualAverage": "Año promedio",
        "stormEvent": "Tormenta con un rango percentil de 85%",
        "runoffContributionArea": "Área de contribución de escurrimiento externo",
        "total": "Total",
        "noGroundwaterBasin": "Sin cuenca de agua subterránea",
        "inhr": "pulgadas/hora",
        "Very High": "Muy Altas",
        "High": "Altas",
        "Moderate": "Moderadas",
        "Low": "Bajas",
        "Very Low": "Muy Bajas",
        "Unknown": "Desconocido",
        "noDataAvailable": "No hay datos disponibles para tu región",
        "siteRainfall": "Precipitación de la ubicación",
        "offsiteRunoff": "Escurrimiento externo",
        "siteFooterText": "Esta ubicación fue diseñada utilizando el Living Infrastructure Field Kit.",
        "footerText2": "Creado con cuidado y comunidad por Accelerate Resilience L. A. (ARLA) y Spherical. Se publicará bajo una licencia de código abierto. Accelerate Resilience L. A. es un proyecto patrocinado por Rockefeller Philanthropy Advisors.",
        "footerText3": "livinginfrastructure.org"
    },
    "DataLayerPopup": {
        "hide": "Ocultar",
        "layerDetails": "Detalles de la Capa",
        "loading": "Cargando…",
        "noData": "Sin datos"
    },
    "HideLayerButton": {
        "show": "Mostrar",
        "hide": "Ocultar"
    },
    "MapLegend": {
        "heading": "Capas",
        "expand": "Expandir leyenda",
        "collapse": "Contraer leyenda"
    },
    "PopupFeatureItem": {
        "visitWebsite": "Visitar sitio web",
        "percentile": "percentil",
        "inch": "pulgada",
        "inches": "pulgadas",
        "miles": "millas",
        "sqmi": "millas cuadradas",
        "feet": "pies",
        "sqft": "pies cuadrados",
        "acres": "acres",
        "meters": "metros",
        "count": "cuentas",
        "in": "pulgadas",
        "percent": "%",
        "%": "%",
        "fahrenheit": "°F",
        "F": "°F",
        "dollars": "dólares",
        "gal": "galones",
        "tons": "toneladas",
        "years": "años",
        "coordinate": "coordinar",
        "in/hr": "pulgadas/hora"
    },
    "LayerName": {
        "layer": "capa de $layerName",
        "removeLayer": "Borrar capa de $layerName",
        "learnMore": "Aprende más sobre"
    },
    "SketchLayersMenu": {
        "sites": "Ubicaciones",
        "comments": "Comentarios",
        "footprints": "Huellas de Remedio",
        "remedies": "Remedios",
        "sketchVisibility": "Visibilidad",
        "sitesIconAlt": "Un polígono de cuatro lados que representa una ubicación.",
        "remediesIconAlt": "Una calcomanía en forma de nube que representa remedios.",
        "footprintsIconAlt": "Un par de huellas que alterna huellas",
        "commentIconAlt": "Un par de burbujas de diálogo que representan comentarios."
    },
    "LevelArrows": {
        "positive": "positivo",
        "negative": "negativo",
        "outOf": "de",
        "arrows": "flechas"
    },
    "IdentifyStressors": {
        "heading": "Identificar estresores",
        "subhead": "Series en video",
        "description": "<p class=\"mb-4\">Las comunidades de todo el condado de L.A. experimentan diferentes estresores, desde exposición al calor hasta contaminación del aire. Estos estresores empeoran con la falta de inversión histórica, el uso ineficiente del suelo y cambio climático. Identificar los estresores es un paso importante para diseñar la infraestructura viva y abordar las necesidades de nuestra comunidad.</p><p>A continuación, estos videos destacan a cuidadanos de Los Ángeles hablar sobre los estresores ambientales que afectan su diario vivir. ¿En dónde ve estresores como estos en su comunidad? ¿Cuáles son las causas? ¿Cuáles son los efectos?</p>",
        "shadeEquity": "Equidad de sombras de árboles",
        "highwayPollution": "Contaminación de las autopistas",
        "waterPollution": "Contaminación del agua",
        "landscapeTransformation": "Transformación de paisaje",
        "playgroundHeat": "Calor en un parque infantil",
        "shadeEquityAlt": "Un residente de Los Ángeles está de pie frente a una parada de autobús.",
        "highwayPollutionAlt": "Un residente de Los Ángeles está de pie en un puente peatonal.",
        "waterPollutionAlt": "Un residente de Los Ángeles sostiene una caña de pescar frente al Río Los Ángeles.",
        "landscapeTransformationAlt": "El propietario de una casa sostiene una manguera de jardín en su jardín delantero.",
        "playgroundHeatAlt": "Un niño está de pie en un parque infantil."
    },
    "ConsiderRemedies": {
        "heading": "Considerar Remedios",
        "subhead": "Contenido explorable",
        "description": "Esta interacción muestra fotos de diferentes tipos de ubicaciones superpuestas con remedios ilustrados. Fomenta la exploración de remedios específicos y sus efectos, al mismo tiempo que ofrece información sobre cómo pueden combinarse para mitigar los estresores de la ubicación.",
        "exampleProjects": "Proyectos de ejemplo",
        "emptyState": "Haz clic en un proyecto de ejemplo para explorar remedios y cómo funcionan en diferentes tipos de proyectos y ubicaciones.",
        "learnMore": "Infórmese sobre las oportunidades de financiamiento.",
        "prev": "Anterior",
        "firstRemedy": "Primer remedio",
        "nextRemedy": "Siguiente remedio",
        "restart": "Reiniciar",
        "mousePrompt": "Pasa el mouse sobre la escena para descubrir remedios en acción.",
        "useCaseNames": [
            "Residencial",
            "Jardín comunitario",
            "Campo deportivo",
            "Escuela",
            "Parque",
            "Aguas pluviales",
            "Planes de resiliencia",
            "Silvicultura urbana",
            "Calles verdes",
            "Transporte",
            "Centro comunitario"
        ],
        "useCaseDescriptions": [
            "<p>¿Cómo pueden las casas residenciales convertirse en infraestructura viva?</p><p>Explora remedios como pavimento permeable, almacenamiento de agua en el sitio, paneles solares y jardines ecológicos para aprender más sobre sus efectos de múltiples beneficios.</p>",
            "<p>Los jardines comunitarios pueden ayudar a regenerar la vida, fomentar la participación vecinal y aumentar la belleza y la resiliencia.</p><p>Explora remedios como bancos, huertos y árboles frutales para aprender más sobre sus efectos de múltiples beneficios.</p>",
            "<p>¿Sabías que los campos deportivos pueden ser excelentes ubicaciones para almacenar e infiltrar agua?</p><p>Explora remedios como estanques de infiltración, equipos de ejercicio, iluminación, fuentes de agua y áreas deportivas para aprender sobre sus efectos de múltiples beneficios.</p>",
            "<p>Los patios escolares no tienen que ser calurosas extensiones de asfalto.</p><p>Explora cómo remedios como estructuras de sombra, áreas de juegos, jardines ecológicos, letreros interpretativos y tanques de almacenamiento pueden ayudar a que los patios escolares se conviertan en lugares más frescos y saludables para jugar.</p>",
            "<p>El acceso a parques y espacios verdes está relacionado con comunidades más saludables y resilientes.</p><p>Explora remedios como céspedes, árboles de sombra, espacios de reunión al aire libre, baños y jardines de lluvia para aprender más sobre sus efectos de múltiples beneficios.</p>",
            "<p>En la cuenca de L.A., gran parte del agua de lluvia se convierte en escorrentía contaminada que termina en el océano Pacífico.</p><p>Explora remedios como estanques de almacenamiento, humedales y senderos para aprender más sobre cómo recolectar agua de lluvia puede ayudar a prevenir inundaciones y la contaminación del agua río abajo, aumentar la resiliencia hídrica local, crear hábitat y convertirse en lugares para una recreación saludable.</p>",
            "<p>Las comunidades que planifican para condiciones como el calor y las inundaciones pueden mitigar mejor sus impactos adversos.</p><p>Explora remedios como estaciones de enfriamiento e higiene, arte y tanques de infiltración para aprender cómo pueden ayudar a mejorar la salud pública, aumentar el enfriamiento y el acceso al agua, y crear un sentido de pertenencia.</p>",
            "<p>Los árboles y las plantas mejoran las ciudades al limpiar el aire, crear hábitats y proporcionar sombra al suelo.</p><p>Explora remedios como árboles de amortiguamiento, árboles de sombra y jardines ecológicos para aprender más sobre sus roles en la creación de espacios frescos y biodiversos que tienen una buena calidad del aire.</p>",
            "<p>¿Cómo pueden las calles convertirse en infraestructura viva?</p><p>Explora remedios como calles lentas, árboles de sombra, ciclovías y bioswales para aprender más sobre cómo las calles pueden aumentar la salud y movilidad de la comunidad, al mismo tiempo que proporcionan temperaturas más frescas y hábitats biodiversos.</p>",
            "<p>Aumentar la movilidad peatonal y el transporte público reduce el smog y crea comunidades más saludables.</p><p>Explora remedios de transporte como paradas de autobús y ciclovías para aprender más sobre cómo pueden aumentar la movilidad de una ciudad y mejorar la salud pública y la recreación.</p>",
            "<p>Los centros comunitarios sirven como puntos críticos para abordar la desconexión dentro de las comunidades.</p><p>Explora remedios como edificios de centros comunitarios, áreas de chapoteo, bancos, estacionamientos para bicicletas y áreas de estacionamiento para aprender más sobre cómo pueden proporcionar espacios frescos para recrearse y fortalecer la identidad y el propósito comunitario.</p>"
        ]
    },
    "PrimerLibrary": {
        "heading": "Cartillas",
        "description": "Profundice sus conocimientos sobre las infraestructuras vivas a través de videos, artículos y contenidos interactivos.",
        "backgroundImageAlt": "Una sola gota de agua del lago del Parque Magic Johnson contiene una multitud de microorganismos sanos de muchas formas y tamaños, como esferas, varillas y espirales.",
        "minutes": "minutos",
        "types": {
            "video": "Video",
            "interactive": "Interactivo"
        },
        "primers": {
            "identify-stressors": {
                "title": "Identificar estresores",
                "description": "Observe cómo los residentes exploran los diversos factores de estrés medioambiental en la zona de Los Ángeles.",
                "alt": "Un residente de Los Ángeles frente al río LA."
            },
            "think-differently-about-water": {
                "title": "Piense diferente sobre el agua",
                "description": "Observe el potencial inexplorado de lo que es posible cuando se adopta un planteamiento de sistemas vivos para sanar el agua y la tierra aquí mismo, en Los Ángeles.",
                "alt": "Una imagen de la cuenca de Los Ángeles muestra dónde vierte al océano la escorrentía del agua de lluvia de la ciudad."
            },
            "living-infrastructure-invitation": {
                "title": "Invitación a la infraestructura viva",
                "description": "Explore la asociación evolutiva y recíproca entre la actividad humana y el entorno vivo.",
                "alt": "Dos personas sentadas en una mesa de pícnic en un parque bajo un gran roble sombreado. Una ilustración se superpone con alguien montando en bicicleta. Una mariposa pasa flotando con la pregunta: “¿Qué necesita aquí?”"
            },
            "living-infrastructure-in-action": {
                "title": "Vea la infraestructura viva en acción",
                "description": "Vea cómo las infraestructuras vivas ayudaron a una comunidad a recuperarse tras una injusticia medioambiental.",
                "alt": "El parque Magic Johnson se superpone a una ilustración de bulliciosos bancos de peces, tortugas, aves y una exuberante vegetación acuática. Al fondo, un sistema de filtración de aguas pluviales."
            },
            "consider-remedies": {
                "title": "Considerar Remedios",
                "description": "Interactúe con diversas herramientas correctoras que refuerzan los sistemas vivos frente a los factores de estrés medioambientales.",
                "alt": "A una casa con la entrada desnuda se le superpone una ilustración de plantas y flores respetuosas con el clima y un barril de lluvia para recoger el agua de lluvia del tejado de la casa."
            },
            "landscape-transformation": {
                "title": "Transformación del paisaje",
                "description": "Descubre las ventajas y desventajas de los distintos enfoques paisajísticos a través de la transformación de un jardín.",
                "alt": "Un surtido de remedios, como un jardín nativo, captación de lluvia y adoquines permeables, se ilustran sobre una foto de una casa promedio."
            }
        }
    },
    "RemediesAndEffects": {
        "remedies": "Remedios",
        "benefits": "Beneficios",
        "cost": "Presupuesto",
        "footprintSize": "Los beneficios de este remedio pueden cambiar según el tamaño de su huella personalizable. Los beneficios mostrados aquí se basan en la huella predeterminada de",
        "sqft": "pies cuadrados",
        "remedyCost": "El costo de este remedio puede cambiar según el tamaño de su huella personalizable. Los costos mostrados aquí se basan en la huella predeterminada de"
    },
    "ReferencesHeader": {
        "remedy": "remedios",
        "effect": "beneficios",
        "dataLayer": "Capas de datos",
        "collapseSidebar": "Colapsar barra lateral",
        "openSidebar": "Abrir barra lateral"
    },
    "RemedySticker": {
        "clickToDrag": "Haga clic para arrastrar a su sitio",
        "addToSketch": "Añadir al sitio",
        "add": "Añadir",
        "added": "Añadido",
        "clickToAdd": "Haga clic para agregar a su sitio"
    },
    "MissingResults": {
        "crystalBallAlt": "Una animación de una mariposa batiendo sus alas dentro de una bola de cristal que pulsa con energía.",
        "missingSearchResults": "No pudimos encontrar ninguna coincidencia. Intenta una nueva búsqueda o háznos saber qué estás buscando.",
        "tellUs": "Díganos qué nos falta."
    },
    "EmptyPanel": {
        "createSite": "Crear un sitio",
        "addRemedy": "Agregar un remedio",
        "saveSiteAddRemedies": "Guarda tu sitio para agregar remedios",
        "siteInfoHeader": "Conoce un lugar",
        "siteInfoText": "Crea un sitio para explorar el uso del suelo, la propiedad, los límites, las cuencas y los territorios indígenas.",
        "siteInfoAlt": "Una ilustración de la Isla Tortuga.",
        "dataInsightsHeader": "Descubre qué hace único a este lugar",
        "dataInsightsText": "Crea un sitio para conocer un lugar a través de los datos: desde el calor y el flujo del agua hasta la salud de la comunidad y el hábitat.",
        "dataInsightsAlt": "Una ilustración de manos sosteniendo agua.",
        "costsBenefitsHeader": "Ver los efectos de tu diseño",
        "costsBenefitsProjectText": "Una vez que comiences a agregar remedios, puedes ver los costos y beneficios estimados de tu proyecto. Experimenta combinando remedios; realiza un seguimiento de cómo cambian y crecen los beneficios.",
        "costsBenefitsAllSitesText": "Una vez que comiences a agregar remedios, puedes ver los costos y beneficios estimados de tus ubicaciones. Experimenta combinando remedios; observa cómo los beneficios cambian y crecen.",
        "costsBenefitsSiteText": "Una vez que comiences a agregar remedios, puedes ver los costos y beneficios estimados de tu ubicación. Experimenta combinando remedios; observa cómo los beneficios cambian y crecen.",
        "costsBenefitsViewerHeader": "Aún no hay costos ni beneficios",
        "costsBenefitsViewerText": "Los costos y beneficios del trabajo de diseño de tu equipo aparecerán aquí a medida que se agreguen remedios.",
        "costsBenefitsAlt": "Una ilustración de alguien dibujando un diseño.",
        "communityVoiceHeader": "Captura la voz de la comunidad",
        "communityVoiceDescription": "Comenta con la opinión de la comunidad, el conocimiento local o información sobre las condiciones del sitio. Continúa la conversación con respuestas.",
        "commentsHeader": "Aún no hay comentarios",
        "commentsDescription": "Los comentarios de otros miembros del proyecto aparecerán aquí cuando se agreguen.",
        "addComment": "Agregar un comentario",
        "saveSiteComments": "Guarda tu sitio para dejar comentarios",
        "commentsAlt": "Una ilustración de dos personas de pie en un paisaje verde, señalando y discutiendo planes para el sitio.",
        "createStory": "Crear una historia",
        "storiesHeader": "Comparte una historia de este lugar",
        "storiesText": "",
        "storiesViewerText": "",
        "storiesAlt": "Una ilustración de un gran roble frondoso con personas descansando debajo."
    },
    "TipsResourcesTab": {
        "tips": "Consejos",
        "resources": "Recursos"
    },
    "EmptyTab": {
        "nothingHere": "No hay nada aquí. ¿Tienes alguna pregunta?",
        "getAdvice": "Obtener consejos",
        "altText": "Una bandada de pájaros multicolores batiendo sus alas."
    },
    "RemediesPanel": {
        "remedies": "Remedios",
        "closePanel": "Cerrar panel de remedios",
        "search": "Buscar un remedio…",
        "searchDescription": "Los resultados se actualizan automáticamente mientras escribes.",
        "filterTooltip": "Filtrar",
        "filter": "Filtrar remedios",
        "clearSearch": "Borrar búsqueda",
        "remove": "Eliminar",
        "learnMore": "Aprende más sobre",
        "filtering": "Filtrar"
    },
    "UILayerItem": {
        "learnMore": "Aprende más sobre",
        "selectLayer": "Seleccionar capa",
        "deselectLayer": "Desmarcar capa",
        "expandPack": "Expandir paquete",
        "collapsePack": "Colapsar paquete",
        "withLayers": "con %n capas",
        "withSelectedLayers": "con %numerator seleccionado de %denominator capas",
        "selectAllLayers": "Selecciona todas las capas en el paquete.",
        "selectAll": "Seleccionar todo",
        "deselectAll": "Desmarcar todo",
        "packs": "Paquetes:",
        "pack": "Paquete:",
        "counterText": "%numerator seleccionado de %denominator capas"
    },
    "FiltersDropdown": {
        "heading": "Filtrar Remedios",
        "exit": "Cerrar filtros",
        "benefits": "Beneficios"
    },
    "DataLayerSpecs": {
        "lastUpdated": "Última actualización",
        "relatedEffects": "Beneficios relacionados:",
        "packs": "Paquetes:",
        "pack": "Paquete:"
    },
    "DataLayerDocumentation": {
        "ranges": "Rangos",
        "categories": "Categorías",
        "methodology": "Metodología"
    },
    "DataSources": {
        "dataSources": "Fuentes de Datos",
        "lastUpdated": "Última actualización"
    },
    "LeftPanel": {
        "siteInfo": "Información de la ubicación",
        "dataInsights": "Perspectivas de Datos",
        "costsBenefits": "Costos y Beneficios",
        "comments": "Comentarios",
        "site": "Ubicación",
        "siteTooLarge": "Alguna información no está disponible actualmente para ubicaciones más grandes de ~100 millones de pies cuadrados.",
        "invalidPolygon": "Tu sitio no puede tener bordes que se entrelacen. Considera editar el sitio.",
        "apiError": "El perfil de tu sitio no se puede cargar en este momento.",
        "selectSite": "¿Seleccionar esta ubicación?",
        "stories": "Historias"
    },
    "SitesListPanel": {
        "siteInfoInstructions": "Elige una ubicación para ver la información correspondiente.",
        "dataInsightsInstructions": "Elige una ubicación para ver los datos correspondientes."
    },
    "SiteTitleCard": {
        "noDescription": "Sin descripción aún."
    },
    "SiteRowInner": {
        "creator": "Creator The word \"Creator\" in English translates to **Creador** in Mexican Spanish.",
        "editSiteDetails": "Editar detalles de la ubicación",
        "showMore": "Mostrar más",
        "showLess": "Mostrar menos"
    },
    "SketchPanel": {
        "selectASite": "Selecciona una ubicación",
        "drawSite": "Dibujar una ubicación",
        "zoomOrSearch": "Acércate y toca un terreno para crear un sitio o",
        "drawYourSite": "dibuja el tuyo propio"
    },
    "UIStarIcon": {
        "pin": "Fijar"
    },
    "LayerPackTab": {
        "layersInPack": "Capas en este paquete"
    },
    "ToggleLayerButton": {
        "useDataLayer": "Usar Capa de Datos",
        "useLayerPack": "Usar Paquete de Capas",
        "dataLayerOn": "Capa de Datos Activada",
        "layerPackOn": "Paquete de Capas Activada"
    },
    "OpportunitiesSection": {
        "opportunities": "Oportunidades",
        "showAll": "Mostrar todo",
        "showLess": "Mostrar menos",
        "opportunitiesTooltip": "Las oportunidades se basan en los datos disponibles y son relativas al condado de Los Ángeles. Un nivel alto indica que pueden ser necesarias mejoras. Estos datos deben complementarse con la opinión de la comunidad y estudios del sitio.",
        "Very High": "Oportunidades Muy Altas",
        "High": "Oportunidades Altas",
        "Moderate": "Oportunidades Moderadas",
        "Low": "Oportunidades Bajas",
        "Very Low": "Oportunidades Muy Bajas",
        "Unknown": "No hay datos disponibles",
        "pin": "Fijar"
    },
    "DataInsightsPanel": {
        "land": "Tierra",
        "yes": "Sí",
        "no": "No",
        "programs": "Programas"
    },
    "PrimerHeader": {
        "home": "Inicio",
        "learn": "Aprender"
    },
    "UIPersistentPanel": {
        "options": "Opciones",
        "expand": "Expandir",
        "collapse": "Contraer",
        "expandSketchPanel": "Expandir Panel del Sitio",
        "collapseSketchPanel": "Contraer Panel del Sitio"
    },
    "MapSubtools": {
        "editShape": "Editar forma",
        "duplicate": "Duplicar",
        "delete": "Borrar",
        "click": "Clic",
        "draw": "Dibujar",
        "parcelSelectDisabled": "No se puede hacer clic para seleccionar terreno fuera del condado de Los Ángeles"
    },
    "SiteDeleteConfirmation": {
        "confirmDeleteHeading": "¿Está seguro de que desea borrar este sitio?",
        "confirmDelete": "Una vez que borre este sitio, ni usted ni nadie de este proyecto podrá acceder a él."
    },
    "OnboardingPanelButtons": {
        "cancel": "Cancelar",
        "selectSite": "Seleccionar ubicación",
        "saveAndSignup": "Guardar y registrarse"
    },
    "ParticipantLinkBanner": {
        "shareWarning": "Hemos actualizado nuestros enlaces de compartición, y este enlace ya no es compatible para quienes lo compartiste. <a href=\"https://help.la.livinginfrastructure.org/en/articles/9930995-sharing\" target=\"_blank\">Aquí tienes un artículo</a> que explica cómo invitar colaboradores.",
        "needAccess": "Para acceder a este proyecto, comunícate con la persona que lo compartió y pídele que invite tu dirección de correo electrónico. <a href=\"https://help.la.livinginfrastructure.org/en/articles/9930995-sharing\" target=\"_blank\">Aquí tienes un artículo</a> que explica cómo invitar colaboradores."
    },
    "PublicLinkBanner": {
        "contributeOnlyMessage": "Ahora estás contribuyendo a este proyecto. Para crear tu propio proyecto, regístrate con una cuenta gratuita.",
        "contributeOnlyMessageAuthenticated": "Ahora estás contribuyendo a este proyecto.",
        "viewOnlyMessage": "Solo puedes ver este proyecto. Para crear tu propio proyecto, regístrate con una cuenta gratuita.",
        "viewOnlyMessageAuthenticated": "Solo puedes ver este proyecto.",
        "closeButton": "Cerrar",
        "signupButton": "Registrarse"
    },
    "ContributorModal": {
        "headerText": "Unirse al proyecto",
        "formSubHeaderText": "Agregar tu nombre es opcional y será visible para cualquier persona que vea este proyecto.",
        "joinDisclaimer": "Al hacer clic en /“Comenzar”, aceptas nuestros <a href=\"https://livinginfrastructure.org/terms\">Términos de Servicio</a> y nuestra <a href=\"https://livinginfrastructure.org/privacy\">Política de Privacidad</a>.",
        "firstNameLabel": "Nombre",
        "lastNameLabel": "Apellido",
        "firstNamePlaceholder": "Ingresa tu nombre",
        "lastNamePlaceholder": "Ingresa tu apellido",
        "submitButtonText": "Comenzar",
        "errorText": "Algo salió mal, por favor intenta de nuevo."
    },
    "RequestNewLink": {
        "requestNewLink": "Solicitar un nuevo enlace",
        "subheader": "<p>¡Bienvenido de nuevo al actualizado Field Kit!</p> <p>Hemos actualizado nuestros enlaces de compartición, y este enlace ya no es compatible. Para acceder a este proyecto, comunícate con la persona que lo compartió y pídele que invite tu dirección de correo electrónico.</p> <p><a href=\"https://help.la.livinginfrastructure.org/en/articles/9930995-sharing\" target=\"_blank\">Aquí tienes un artículo</a> que explica cómo invitar colaboradores.</p>",
        "gifAltText": "Para acceder a este proyecto, comunícate con la persona que lo compartió y pídele que invite tu dirección de correo electrónico."
    },
    "UITabs": {
        "benefitsCosts": "Beneficios y Costos",
        "pairings": "Pares",
        "tipsResources": "Consejos y Recursos",
        "remedies": "Remedios",
        "dataLayers": "Capas de datos",
        "documentation": "Documentación",
        "tips": "Consejos",
        "benefits": "Beneficios",
        "conditions": "Condiciones",
        "details": "Detalles",
        "sites": "Ubicaciones",
        "layers": "Capas",
        "summary": "Resumen"
    },
    "CollaborateBanner": {
        "toJoin": "Para unirte a",
        "please": "¡por favor",
        "signup": "registrarse",
        "login": "inicia sesión"
    },
    "BrowserError": {
        "checkBrowserSettings": "Revisa la configuración de tu navegador",
        "subheader": "El mapa del Kit de Campo de Infraestructura Viva está experimentando problemas. Para acceder a este proyecto, es posible que necesites revisar la configuración de tu navegador. <a href=\"https://help.la.livinginfrastructure.org/en/articles/10487073-troubleshooting-your-browser-settings\">Aprende más</a>",
        "altText": "Una ilustración de un ave playera hurgando en aguas poco profundas, con ondas formándose alrededor de sus patas."
    },
    "GuidebookWelcome": {
        "heroAlt": "Una ilustración de vida silvestre como un pájaro, una mariposa y una rana saliendo de una flor en plena floración.",
        "welcomeHeading": "Bienvenido al manual.",
        "welcomeText": "El manual es tu centro de conocimiento sobre infraestructura viva y compañero de proyectos; solo busca el ícono del libro para desbloquear consejos, ideas e inspiración mientras avanzas. Dentro, encontrarás artículos útiles para cada remedio, beneficio y capa de datos en el Kit de Campo. ¿Listo para sumergirte?",
        "welcomeCTA": "¿Listo para sumergirte?",
        "remediesHeading": "Remedios",
        "remediesAlt": "Iconos en forma de calcomanías de árboles, una estructura de sombra y un área de juegos en un mapa, además de un gráfico de beneficios.",
        "remediesText": "El Kit de Campo contiene una biblioteca de más de 40 remedios de infraestructura viva, como jardín de lluvia, tanque de almacenamiento y estructura de sombra, cada uno con su propio artículo de guía dedicado. Navega por la biblioteca para aprender más.",
        "benefitsHeading": "Beneficios",
        "benefitsAlt": "Íconos similares a stickers de beneficios como árboles y un área de juegos superpuestos en un mapa de ubicación del sitio.",
        "benefitsText": "Agregar remedios a tu sitio muestra un resumen de sus costos y beneficios estimados. Haz clic en el manual para profundizar en los beneficios de los remedios, como el enfriamiento, la salud pública y el suministro de agua.",
        "dataLayersHeading": "Capas de Datos",
        "dataLayersAlt": "Un mapa de riesgo de inundaciones de la ciudad de Alhambra con un gráfico que muestra los niveles de riesgo de 0 a más de 5.",
        "dataLayersText": "Utiliza la guía para aprender más sobre la metodología y las fuentes de datos detrás de algunos de los conjuntos de datos más detallados del Condado de Los Ángeles. Cada artículo incluye consejos relevantes para guiar tu proyecto y ayudarte a aprovechar al máximo los datos."
    },
    "NoDataHere": {
        "noDataAlt": "Una ilustración de un elefante mirando un pozo de alquitrán con 'Urban Light' de LACMA de fondo.",
        "noDataMessage": "Estos datos solo están disponibles para sitios dentro del condado de Los Ángeles. Echa un vistazo a un <a href=\"https://la.livinginfrastructure.org/workshops/7a335a32-33a0-4b01-99ca-b26cee0c3fa8/sketches/028facd1-923d-41cf-aee1-0ec4e9de6ceb\" target=\"_blank\" style=\"text-decoration: underline;\">sitio de muestra</a> para ver un perfil completo del sitio."
    },
    "ProjectOptionsDropdown": {
        "options": "Opciones",
        "rename": "Renombrar",
        "share": "Compartir",
        "duplicate": "Duplicar",
        "projectDeleted": "Proyecto eliminado",
        "delete": "Borrar",
        "confirmDeleteHeading": "¿Estás seguro de que deseas eliminar este proyecto?",
        "confirmDelete": "Una vez que elimines un proyecto, tú y todos los que estén en este proyecto no podrán acceder a él."
    },
    "StormwaterSettingsDropdown": {
        "settings": "Configuración de Datos de Precipitación",
        "timespan": "The translation of \"Timespan\" to Mexican Spanish is \"Duración\".",
        "yearlyAverage": "Promedio anual",
        "stormEvent": "Evento de tormenta",
        "units": "Unidades",
        "gallon": "Galón",
        "gallons": "Galones",
        "acreFoot": "Acre-pie",
        "acreFeet": "Acre-pies",
        "people": "Personas",
        "personYear": "persona-año",
        "personYears": "The translation of \"person-years\" to Mexican Spanish is \"años-persona\".",
        "yearlyAverageDescription": "promedio anual",
        "stormEventDescription": "tormenta del percentil 85",
        "close": "Cerrar"
    },
    "UIRadioButton": {
        "selected": "Botón de radio seleccionado",
        "unselected": "Botón de radio no seleccionado"
    },
    "InvalidVersionModal": {
        "reloadRequired": "Recarga requerida",
        "modalBody": "Una nueva versión del Living Infrastructure Field Kit está disponible. Recarga para acceder a tu proyecto y",
        "latestFeaturesLink": "las últimas funciones",
        "reload": "Recargar"
    },
    "useAddSite": {
        "defaultSiteNamePrefix": "Ubicación",
        "siteSuccess": "Ubicación creada exitosamente",
        "duplicateError": "Ocurrió un error al duplicar tu ubicación.",
        "duplicateSuccess": "Ubicación duplicada correctamente."
    },
    "SettingsSidebar": {
        "settings": "Configuraciones",
        "communicationPreferences": "Preferencias de comunicación",
        "userProfile": "Perfil"
    },
    "CommunicationPreferences": {
        "communicationPreferences": "Preferencias de comunicación",
        "emailPreferencesSaved": "Preferencias de correo electrónico actualizadas.",
        "toolAnalyticsSaved": "Análisis de herramientas actualizado.",
        "saveError": "No se pudieron actualizar tus preferencias. Inténtalo de nuevo.",
        "profile": "Perfil",
        "emailUpdates": "Actualizaciones por correo electrónico",
        "emailUpdatesInfo": "Suscríbete a nuestro boletín para obtener información exclusiva sobre infraestructura viva, consejos y las últimas novedades del Living Infrastructure Field Kit.",
        "toggleEmailUpdates": "Activar actualizaciones por correo electrónico",
        "toggleTracking": "Alternar seguimiento",
        "privacyPolicy": "Política de Privacidad",
        "toolAnalytics": "Análisis de herramientas",
        "trackingToolInfo": "El seguimiento dentro del producto nos ayuda a identificar qué funciones son las más populares y dónde ocurren problemas, lo que nos permite mejorar para satisfacer mejor las necesidades de nuestras comunidades. Conoce nuestras prácticas de datos en nuestra"
    },
    "UserProfile": {
        "profile": "Perfil",
        "firstNameLabel": "Nombre de pila",
        "lastNameLabel": "Apellido",
        "emailLabel": "Correo electrónico",
        "organizationLabel": "Organización",
        "avatarColorLabel": "Color del avatar",
        "firstNamePlaceholder": "Ingresa el nombre de pila",
        "lastNamePlaceholder": "Ingresa el apellido",
        "organizationPlaceholder": "Ingresa la organización",
        "firstNameError": "Por favor, ingresa tu nombre.",
        "lastNameError": "Por favor, ingresa tu apellido.",
        "emailError": "Por favor, introduce una dirección de correo electrónico válida.",
        "organizationError": "Por favor, ingresa tu organización.",
        "errorMessage": "Error al registrarse",
        "errorAccountExists": "Ya existe una cuenta con este correo electrónico",
        "passwordLabel": "Contraseña",
        "editPassword": "Editar contraseña",
        "deleteAccount": "Eliminar cuenta",
        "updated": "actualizado",
        "saveError": "Ocurrió un error al guardar.",
        "deleteConfirmTitle": "¿Estás seguro de que deseas eliminar tu cuenta?",
        "deleteConfirmText": "Una vez que elimines tu cuenta, perderás la capacidad de acceder al Field Kit y a todos tus proyectos.",
        "deleteError": "Ocurrió un error al eliminar tu cuenta.",
        "emailInUseError": "Este correo electrónico ya está en uso.",
        "editAvatarColorLabel": "Editar color de avatar"
    },
    "EditPasswordModal": {
        "editPassword": "Editar contraseña",
        "currentPassword": "Contraseña actual",
        "newPassword": "Nueva contraseña",
        "passwordsMustMatch": "Passwords must match.",
        "forgotPassword": "¿Olvidó su contraseña?",
        "save": "Guardar",
        "passwordUpdated": "Contraseña actualizada.",
        "passwordError": "Ocurrió un error al actualizar tu contraseña.",
        "currentPasswordError": "Contraseña actual incorrecta."
    },
    "DuplicateWorkshopModal": {
        "title": "Proyecto duplicado",
        "description": "¿Qué te gustaría duplicar?",
        "duplicateNameError": "Ya existe un sitio con este título. Por favor, intenta con un título diferente.",
        "updateSketchError": "Tu sitio no puede ser actualizado en este momento. Te sugerimos reiniciar tu conexión a internet o buscar una más rápida. Si eso no funciona, ten paciencia mientras resolvemos el problema de nuestro lado. ¡Gracias por tu paciencia!",
        "sketchDuplicated": "Proyecto duplicado.",
        "confirmCloseHeading": "¿Estás seguro de que deseas descartar estas Opciones de Duplicación?",
        "confirmClose": "Una vez que descartes estas Opciones de Duplicación, no podrás acceder a ellas nuevamente.",
        "siteNameLabel": "Ubicación(es)",
        "remediesNameLabel": "Remedios",
        "duplicateSubmitButton": "Duplicar"
    },
    "ZoomToViewButton": {
        "zoomToViewData": "Acércate para ver los datos"
    },
    "UIDropdownItems": {
        "dropdownItems": "Opciones del menú desplegable"
    },
    "SphericalAdmin": {
        "sortBy": "Ordenar por",
        "search": "Buscar personas",
        "searchPlaceholder": "Buscar por nombre, correo, organización o ID",
        "clearSearch": "Borrar búsqueda",
        "noMatches": "Ninguna persona coincide con tu búsqueda"
    },
    "UIPanelCard": {
        "pin": "Fijar",
        "add": "Añadir",
        "toMap": "al mapa"
    },
    "PairingCard": {
        "pairing": "Emparejamiento"
    },
    "NavigationSidebar": {
        "collapse": "Contraer menú",
        "expand": "Expandir menú",
        "siteInfo": "Información de ubicación",
        "dataInsights": "Perspectivas de datos",
        "costBenefits": "Costos y beneficios",
        "comments": "Comentarios",
        "unreadComments": "Comentarios no leídos",
        "stories": "Historias"
    },
    "CommentsPanel": {
        "comments": "Comentarios",
        "noFilterResults": "Ningún comentario coincide con estos filtros.",
        "markAllAsReadError": "Algunos comentarios no se pudieron marcar como leídos. Por favor, inténtalo de nuevo."
    },
    "CommentsToolbar": {
        "sort": "Ordenar",
        "sortBy": "Ordenar por",
        "newestFirst": "Más recientes primero",
        "oldestFirst": "Más antiguos primero",
        "unreadFirst": "No leídos primero",
        "filter": "Filtrar",
        "filterComments": "Filtrar comentarios",
        "filterByPerson": "Filtrar por persona",
        "categories": "Categorías",
        "categorized": "Categorizados",
        "uncategorized": "Sin categoría",
        "bothCategories": "Ambos",
        "people": "Personas",
        "noPeople": "Todavía nadie ha comentado.",
        "hideAllComments": "Ocultar todos los comentarios",
        "showAllComments": "Mostrar todos los comentarios"
    },
    "CommentsActiveFilters": {
        "removeFilter": "Eliminar filtro"
    },
    "UIHeader": {
        "back": "Volver",
        "backToProject": "Volver al proyecto",
        "backToHome": "Volver a inicio"
    },
    "UIPaginationDots": {
        "label": "Páginas",
        "page": "Página"
    },
    "MarkAllAsReadButton": {
        "markAllAsRead": "Marcar todo como leído",
        "markAllAsReadUnavailable": "Marcar todo como leído (no disponible porque todos los comentarios ya están leídos)"
    },
    "CommentCard": {
        "unread": "No leído",
        "replyCount": "1 respuesta",
        "repliesCount": "{count} respuestas",
        "anonymous": "ANÓNIMO"
    },
    "CommentsExport": {
        "comments": "Comentarios",
        "footerTextComments": "Estos comentarios se recopilaron utilizando el Kit de Campo de Infraestructura Viva.",
        "projectName": "Nombre del proyecto",
        "thread": "Hilo",
        "replyLevel": "Nivel de respuesta",
        "comment": "Comentario",
        "submitter": "Remitente",
        "latitude": "Latitud",
        "longitude": "Longitud",
        "datetimeSubmitted": "Fecha de envío (UTC)",
        "anonymous": "Anónimo"
    },
    "StoriesPanel": {
        "createStory": "Crear una historia",
        "playStory": "Reproducir historia",
        "editStory": "Editar historia",
        "deleteStory": "Eliminar historia",
        "oneScene": "1 escena",
        "manyScenes": "{count} escenas",
        "confirmDeleteHeading": "Eliminar historia",
        "confirmDelete": "¿Estás seguro de que deseas eliminar esta historia? Esta acción no se puede deshacer.",
        "copyLink": "Copiar enlace",
        "duplicateStory": "Duplicar historia",
        "actionFailed": "Algo salió mal. Inténtalo de nuevo.",
        "linkCopied": "Enlace de la historia copiado",
        "copyOfStory": "Copia de {name}",
        "beta": "Beta",
        "betaMessage": "Esta es una función de lanzamiento limitado. Si necesitas ayuda o quieres compartir comentarios sobre tu experiencia,",
        "betaFeedbackLink": "ponte en contacto con nosotros"
    },
    "StoryEditorBanner": {
        "confirmDeleteSceneHeading": "Eliminar escena",
        "confirmDeleteScene": "¿Estás seguro de que deseas eliminar \"{sceneTitle}\"?",
        "saveFailed": "No se pudo guardar tu historia. Inténtalo de nuevo."
    }
}
